import Loader from './loader';
import PreLoader from './preloader';
import Rotate from './rotate';
import Login from './login';
import Main from './main';

export default {
    Loader,
    PreLoader,
    Rotate,
    Login,
    Main
}